import React from 'react';
import { Card, Button, Badge, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

const MeterCard = ({ meter, onEdit, onDelete, onClick }) => {
  // Get current FY KPI
  const currentFYKpi = meter.financialYearKpis?.find(
    mapping => mapping.financialYear === '2025-2026'
  );

  return (
    <Card className="meter-card h-100">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <strong>{meter.meterName}</strong>
        <div>
          <Button
            variant="outline-primary"
            size="sm"
            className="me-2"
            title="Edit Meter"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(meter);
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            title="Delete Meter"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(meter);
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
          <Badge 
            bg={meter.isActive ? 'success' : 'secondary'} 
            className="me-2"
          >
            <FontAwesomeIcon icon={faCircle} className="me-1" size="xs" />
            {meter.isActive ? 'Active' : 'Inactive'}
          </Badge>
        </div>
      </Card.Header>
      <Card.Body 
        className="clickable-card-body"
        onClick={() => onClick(meter)}
        style={{ cursor: 'pointer' }}
        title="Click to view meter details"
      >
        <div className="meter-details">
          <p>
            <strong>Meter ID:</strong> {meter.meterId}
          </p>
          <p>
            <strong>Gateway ID:</strong> {meter.gatewayId}
          </p>
          <p>
            <strong>Measurement Type:</strong> {meter.measurementType}
          </p>
          {currentFYKpi ? (
            <>
              <p>
                <strong>Module:</strong> {currentFYKpi.kpi.module}
              </p>
              <p>
                <strong>Category:</strong> {currentFYKpi.kpi.category}
              </p>
              {currentFYKpi.subCategory && (
                <p>
                  <strong>Sub Category:</strong> {currentFYKpi.kpi.subCategory}
                </p>
              )}
              <p>
                <strong>KPI:</strong> {currentFYKpi.kpi.kpi}
              </p>
            </>
          ) : (
            <Alert variant="warning" className="py-2 px-2 mb-2 small">
              <strong>⚠️ KPI Not Configured</strong>
              <br />
              <small>Configure KPI to view analytics</small>
            </Alert>
          )}
          <p>
            <strong>Unit:</strong> {meter.unit}
          </p>
          <p className="mb-0">
            <strong>Last Updated:</strong> {moment(meter.updatedAt).format('DD MMM YYYY, HH:mm')}
          </p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MeterCard;